// src/features/api/apiSlice.ts
import { BaseQueryFn, createApi } from "@reduxjs/toolkit/query/react";
import axios, { AxiosRequestConfig } from "axios";
import { baseUrl } from "../../constants/config";
import { store } from "../../app/store";
import { logout } from "../auth/authSlice";

// Definimos nuestro custom baseQuery usando axios
const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: "" }
  ): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig["method"];
      data?: any;
      params?: any;
    },
    unknown,
    {
      status: number;
      data: any;
    }
  > =>
  async ({ url, method, data, params }, api, extraOptions) => {
    try {
      const result = await axios({
        url: baseUrl + url,
        method,
        data,
        params,
        withCredentials: true,
      });
      return { data: result.data };
    } catch (axiosError: any) {
      return {
        error: {
          status: axiosError.response?.status,
          data: axiosError.response?.data || axiosError.message,
        },
      };
    }
  };

// Creamos un baseQuery que maneje la reautenticación:
const axiosBaseQueryWithReauth: BaseQueryFn<
  {
    url: string;
    method: AxiosRequestConfig["method"];
    data?: any;
    params?: any;
  },
  unknown,
  { status: number; data: any }
> = async (args, api, extraOptions) => {
  // Realizamos la petición usando nuestro axiosBaseQuery
  let result = await axiosBaseQuery({ baseUrl })(args, api, extraOptions);

  if (
    result.error &&
    result.error.status === 401 &&
    result.error.data?.message !== "Usuario bloqueado"
  ) {
    // Si se recibe un 401, intentamos refrescar el token
    console.log("Access token expirado, intentando refrescar...");
    const refreshResult = await axiosBaseQuery({ baseUrl })(
      { url: "/auth/refresh", method: "POST" },
      api,
      extraOptions
    );

    if (refreshResult.data) {
      console.log("Token refrescado, reintentando la petición original...");
      // Si refresh fue exitoso, reintentamos la petición original
      result = await axiosBaseQuery({ baseUrl })(args, api, extraOptions);
    } else {
      console.log("No se pudo refrescar el token.");
      // Aquí podrías despachar una acción de logout o manejar el error
      // store.dispatch(logout());
    }
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: "api", // nombre del slice en el store
  baseQuery: axiosBaseQueryWithReauth,
  endpoints: () => ({}),
});
